export default "__VITE_ASSET__449727cd__"